import {ColumnType} from 'priority-web-sdk/enums';
import {Search} from '../../stores/Search';
import {Column} from '../../../Form/serializers/column';
import {AISuggestedFilter} from '../../../../services/rest/llm/aiSuggestedFilters';
import {currentUserPlaceholder} from '../../../../services/rest/llm/constants';
import {getUsername} from '../../../../_shared/GWTBridge/invoke/genPage';
import {Operator} from '../../consts/operators';
import {openDateSearchField} from '../../actions/filters';
import {isValidDate} from '../../../../utils/isValidDate';
import {format as formatDate} from 'date-fns';
import {convertToFnsFormat, getLang} from '../../../../Localization';
import {formatTime} from '../../../../features/Form/utils/date';
import {isHour12Format} from '../../../../features/Form/utils/time';
import {formsStore} from '../../../Form/stores/FormsStore';
import {AIDateOperator} from '../../../../services/rest/enums';

export const getDateValue = (value: string, format: string, dateOptions: Array<string>) => {
    if (!value) return undefined;

    if (isValidDate(value)) {
        return formatDate(new Date(value), convertToFnsFormat(format));
    }
    return dateOptions[AIDateOperator[value]];
};

export function mapAIFilterValues(
    value: Array<string>,
    column: Column,
    operator: Operator,
    dateOptions: Array<string>
) {
    const {type, format} = column;

    if (value) {
        if (type === 'bool') {
            if (typeof value[0] === 'boolean') {
                return value[0];
            }
            return value[0]?.toLowerCase() === 'true';
        } else if (type === 'text') {
            return value.map(val => (val === currentUserPlaceholder ? getUsername() : val));
        } else if (type === 'date') {
            /*
             * "yyyy-mm-dd" - expected date format for Date8 / Date10 from backend
             * "yyyy-mm-dd hh:dd" - expected date format for Date14 from backend
             */
            if (operator === Operator.Before) {
                return {
                    min: undefined,
                    max: getDateValue(value[0], format, dateOptions)
                };
            }
            return {
                min: getDateValue(value[0], format, dateOptions),
                max: value[1] ? getDateValue(value[1], format, dateOptions) : undefined
            };
        } else if (type === 'time') {
            /* "hh:mm" - expected time format for Time5 from backend */
            const lang = getLang();
            return {
                min: value[0] ? formatTime(value[0], isHour12Format(lang)) : undefined,
                max: value[1] ? formatTime(value[1], isHour12Format(lang)) : undefined
            };
        } else if (type === 'number' || type === 'duration') {
            return {
                min: value[0],
                max: value[1]
            };
        }
    }
    return '';
}

export async function setAIFilterValues(
    currentSearch: Search,
    columns: Array<Column>,
    filters: Array<AISuggestedFilter>
) {
    const dateFormat = columns.find(c => c.type === ColumnType.Date)?.format;

    const dateOptionsRes = dateFormat ? await openDateSearchField(dateFormat) : [];
    const dateOptions = dateOptionsRes.map(({value}) => value);

    filters.forEach(item => {
        const column = columns.find(c => c.name === item.column);

        if (column) {
            currentSearch.addFilter(column);

            const filter = currentSearch.filters.get(column.name);
            const operator: number = Operator[item.operator];

            if (typeof operator === 'number') {
                filter.setOperator(operator);
            }

            const mappedValue = mapAIFilterValues(item.values, column, operator, dateOptions);
            const setValue = column.type === ColumnType.Text ? filter.setValues : filter.setValue;

            setValue(mappedValue);
        }
    });
}

export function getPossibleSearchValues(column) {
    if (column.isStatus) {
        return [...formsStore.currentForm.statuses.keys()];
    }

    return null;
}

const isaws = (window as any).priorityParams?.indexOf('_isaws=1') > -1;

export function allowAISearch() {
    const host = window.location?.host || '';
    return isaws || ['localhost', 'd.priority-connect.online'].includes(host);
}

export const supportAISearch = (clearedSavedFilters?: boolean) => {
    const {searchesStore} = formsStore;
    const {generatorSelected} = searchesStore;
    const isNew = generatorSelected?.isNew;

    if (allowAISearch()) {
        if (clearedSavedFilters) {
            return true;
        } else if (isNew) {
            return true;
        }
        return !isNew && generatorSelected?.filters?.size === 0;
    }
    return false;
};
